export default "__VITE_ASSET__da6e7d86__"